export default "__VITE_ASSET__C9$H3VRu__"